import { render, staticRenderFns } from "./InternalFlight.vue?vue&type=template&id=b9c95302&"
import script from "./InternalFlight.vue?vue&type=script&lang=js&"
export * from "./InternalFlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Avijeh.Projects\\Web-Solutions\\IPA.Naga.Web\\Themes\\Eavar.com.V2\\UINew\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9c95302')) {
      api.createRecord('b9c95302', component.options)
    } else {
      api.reload('b9c95302', component.options)
    }
    module.hot.accept("./InternalFlight.vue?vue&type=template&id=b9c95302&", function () {
      api.rerender('b9c95302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Js/Services/Tourism/Flight/InternalFlight.vue"
export default component.exports